import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { UtilityItemWrapper, UtilityItemPrefix, UtilityItemMain, UtilityItemSecondary } from "./utility-item.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  highlighted: PropTypes.bool,
  hoverable: PropTypes.bool,
  magnitude: PropTypes.oneOf(["small", "medium"]),
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  prefix: PropTypes.node,
  secondary: PropTypes.node,
  variant: PropTypes.oneOf(["accent", "danger"])
};
const defaultProps = {
  disabled: false,
  highlighted: false,
  hoverable: false,
  magnitude: "small",
  onClick: void 0,
  onMouseEnter: void 0,
  prefix: void 0,
  secondary: void 0,
  variant: void 0
};
const UtilityItem = forwardRef(
  ({
    children,
    disabled,
    highlighted,
    hoverable,
    magnitude,
    onClick,
    onMouseEnter,
    prefix,
    secondary,
    variant
  }, ref) => /* @__PURE__ */ jsxs(
    UtilityItemWrapper,
    {
      ref,
      disabled,
      $hoverable: hoverable,
      $highlighted: highlighted,
      $magnitude: magnitude,
      onClick: disabled ? void 0 : onClick,
      onMouseEnter,
      tabIndex: 0,
      $variant: variant,
      children: [
        prefix && /* @__PURE__ */ jsx(UtilityItemPrefix, { disabled, children: prefix }),
        /* @__PURE__ */ jsx(UtilityItemMain, { children }),
        secondary && /* @__PURE__ */ jsx(UtilityItemSecondary, { children: secondary })
      ]
    }
  )
);
UtilityItem.propTypes = propTypes;
UtilityItem.defaultProps = defaultProps;
export {
  UtilityItem
};
